import React from "react";
import Seo from "@/components/Seo";
import ServiceHero from "@/components/marketing/service/ServiceHero";
import GoalRouter from "@/components/marketing/service/findfit/GoalRouter";
import ComparisonTable from "@/components/marketing/service/findfit/ComparisonTable";
import WhyDigital24 from "@/components/marketing/service/findfit/WhyDigital24";
import CTASection from "@/components/marketing/CTASection";
import Reveal from "@/components/marketing/Reveal";

export default function FindYourFit() {
  const scrollToGoals = () =>
    document.getElementById("find-your-goal")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="bg-canvas">
      <Seo title="Find Your Fit | Digital24" />
      <ServiceHero
        eyebrow="FIND YOUR FIT"
        title="Not sure which channel you need? Start here."
        subtitle="Three ways to get your story seen: earned coverage, newswire syndication, and guaranteed placements. Each bought on its own. Tell us the goal and we'll point you to the right one."
        primaryCTA={{ label: "Find Your Fit", onClick: scrollToGoals }}
        secondaryCTA={{ label: "Talk to Our Team", to: "/contact" }}
      />
      <GoalRouter />
      <Reveal variant="card">
        <ComparisonTable />
      </Reveal>
      <Reveal variant="card">
        <WhyDigital24 />
      </Reveal>
      <CTASection
        eyebrow="GET STARTED"
        headline="Know your route? Take it."
        subtitle="Pick your channel, or your combination, and get your story moving today."
      />
    </div>
  );
}